// 未登录时的头部组件
<template>
  <!-- 头部 -->
  <div class="header">
    <div class="header-wrapper">
      <el-row>
        <el-col :span="12">
          <div class="header" @click="$router.push('/home')">
            <img src="../../assets/img/logo.svg" alt="" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="bug hidden-sm-and-up">
            <a @click="showMenu"><i class="el-icon-menu menu"></i></a>
          </div>
          <div class="header-right hidden-xs-only">
            <button-user></button-user>
            <button-login
              v-if="$route.path != '/login' && !$cookies.get('userInfo')"
            ></button-login>
            <div
              class="product"
              :class="{ active: isActive == 4 }"
              @click="changeActive(4)"
              v-if="$cookies.get('userInfo')"
            >
              <router-link to="/index">进入平台</router-link>
            </div>
            <button-buy
              :isActive="isActive"
              @click="changeActive(3)"
            ></button-buy>
            <div
              class="product"
              :class="{ active: isActive == 2 }"
              @click="changeActive(2)"
            >
              <router-link to="/app">下载</router-link>
            </div>
            <div
              class="product"
              :class="{ active: isActive == 1 }"
              @click="changeActive(1)"
            >
              <router-link to="/home">产品</router-link>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="menuBox" v-show="menuBox">
        <ul>
          <router-link to="/home">
            <li @click="changeActive(1)">
              <a :class="{ active: isActive == 1 }" href="#">产品</a>
            </li>
          </router-link>

          <router-link to="/app">
            <li @click="changeActive(2)">
              <a :class="{ active: isActive == 2 }" href="#">下载</a>
            </li>
          </router-link>

          <router-link to="/pricing">
            <li @click="changeActive(3)">
              <a :class="{ active: isActive == 3 }" href="#">咨询与购买</a>
            </li>
          </router-link>

          <router-link to="/index" v-if="$cookies.get('userInfo')">
            <li @click="changeActive(4)">
              <a :class="{ active: isActive == 4 }" href="#">进入平台</a>
            </li>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import buttonBuy from "./buttonBuy.vue";
import buttonUser from "./buttonUser.vue";
import buttonLogin from "./buttonLogin.vue";
export default {
  components: {
    buttonBuy,
    buttonUser,
    buttonLogin,
  },
  data() {
    return {
      menuBox: false,
      isActive: null, // 切换导航
    };
  },
  methods: {
    // 展开菜单
    showMenu() {
      this.menuBox = !this.menuBox;
    },
    // 切换导航
    changeActive(current) {
      if (current != 1) {
        // this.destroyed();
      }
      this.isActive = current;
      if (current == 1) {
        this.$router.push("/home");
      } else if (current == 2) {
        this.$router.push("/app");
      } else if (current == 3) {
        this.$router.push("/pricing");
      } else if (current == 4) {
        this.$router.push("/index");
      }
    },
  },
  created() {
    if (this.$route.path == "/home") {
      this.isActive = 1;
    } else if (this.$route.path == "/app") {
      this.isActive = 2;
    } else if (this.$route.path == "/pricing") {
      this.isActive = 3;
    } else if (this.$route.path == "/index") {
      this.isActive = 4;
    }
  },
};
</script>

<style lang="scss" scoped>
.header-wrapper {
  height: 60px;
  width: 100%;
  background: #3c82a8;
  padding: 0px 20px;
  .header {
    line-height: 60px;
    img {
      vertical-align: middle;
      height: 42px;
      cursor: pointer;
    }
    span {
      color: #f1f1f1;
      font-size: 20px;
    }
  }
  .bug {
    cursor: pointer;
    width: 35px;
    height: 60px;
    float: right;
    // padding-right: 20px;
    display: inline-block;
    -webkit-tap-highlight-color: transparent;
    a {
      cursor: pointer;
      width: 35px;
      height: 60px;
      display: inline-block;
      -webkit-tap-highlight-color: transparent;
      text-align: right;
      i {
        color: #fff;
        font-size: 24px;
        line-height: 60px;
      }
    }
  }
  .product {
    // width: 80px;
    display: inline-block;
    height: 60px;
    line-height: 60px;
    color: #f1f1f1;
    float: right;
    cursor: pointer;
    padding: 0 20px;
    text-align: center;
    a {
      color: #f1f1f1;
    }
  }
  .product.active {
    background-color: #206184;
  }
  .menuBox {
    z-index: 1000;
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    text-align: center;
    line-height: 50px;
    background-color: #fff;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li {
      cursor: pointer;
      z-index: 1000;
      a {
        color: #206184;
      }

      a {
        &:hover {
          color: #e4494c;
        }
        &.active {
          color: #176bb4;
          // background-color: #206184;
        }
      }
    }
    .menu-setting {
      border-top: 1px solid #ccc;
      padding-top: 15px;
      .register {
        width: 70px;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        margin-right: 40px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/unloginHeader.vue